// Webpack Imports
import * as bootstrap from 'bootstrap';
import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';


(function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call(document.querySelectorAll('.search-form'), (el) => {
		el.addEventListener('submit', function (e) {
			var search = el.querySelector('input');
			if (search.value.length < 1) {
				e.preventDefault();
				search.focus();
			}
		});
	});

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
	var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
		return new bootstrap.Popover(popoverTriggerEl, {
			trigger: 'focus',
		});
	});

	var swiper = new Swiper(".testimonials-slider", {
		modules: [ Pagination],
		pagination: {
		  el: ".swiper-pagination",
		},
	  });

	document.addEventListener("DOMContentLoaded", function() {
		var enquiryBtns = document.querySelectorAll('.enquiry-btn');
		var enquiryFormContainer = document.querySelector('.enquiry-form-container');
		var enquiryCloseBtn = document.querySelector('.enquiry-close-btn');
	
		enquiryBtns.forEach(function(btn) {
			btn.addEventListener('click', function() {
				enquiryFormContainer.classList.add('active');
			});
		});
	
		enquiryCloseBtn.addEventListener('click', function() {
			enquiryFormContainer.classList.remove('active');
		});
	});

	

})();
